module.exports = __webpack_public_path__ + "static/media/skoteino-nepal-book-cover.6126a6bd.jpg";